import {CookieNames} from "../../../utils/cookie";
import { getCookie, setUserAttribute } from '../../helpers/common';

const MAX_NICKNAME_LENGTH = 100;

export default ({ data }) => {
  const userToken = getCookie(CookieNames.USER_LOGIN_TOKEN);

  // TODO вынести управление состояниями инпута в отдельный модуль
  const baseClass = 'ui-site-input';
  const classValid = `${baseClass}--valid`;
  const classProcessing = `${baseClass}--processing`;
  const classSuccess = `${baseClass}--success`;
  const classError = `${baseClass}--error`;

  // TODO убрать завязку на css классы
  const modal = document.querySelector('.ui-site-thank-you-modal');
  const thankYouModalButton = modal.querySelector('.ui-site-thank-you-modal__button');
  const thankYouModalShowSubscribersButton = modal.querySelector('.ui-site-thank-you-modal__button-open-list');
  const inputElement = modal.querySelector('.ui-site-input__input');
  const inputButton = modal.querySelector('.ui-site-input__button');

  const onKeyUpHandler = input => {
    const parent = input.parentNode;
    const inputValue = input.value.trim();

    if (inputValue.length >= MAX_NICKNAME_LENGTH) {
      parent.className = `${baseClass} ${classError}`;
      return;
    }

    if (inputValue !== '' && inputValue.length >= 3) {
      parent.className = `${baseClass} ${classValid}`;
      return;
    }

    parent.className = baseClass;
  };

  const onSubmitHandler = async input => {
    const { projectId } = data;

    const parent = input.parentNode;
    if (!parent.classList.contains(classValid)) {
      return;
    }

    parent.className = `${baseClass} ${classProcessing}`;

    const inputValue = input.value.trim();

    const requestBody = {
      attributes: [{
        key: 'subscriber_username',
        permission: 'public',
        value: inputValue
      }],
      publisher_project_id: Number(projectId)
    };

    const result = await setUserAttribute(userToken, requestBody);
    if (result.status === 204) {
      parent.className = `${baseClass} ${classSuccess}`;
      thankYouModalButton.classList.add('ui-site-thank-you-modal__button--hidden');
      thankYouModalShowSubscribersButton.classList.remove('ui-site-thank-you-modal__button--hidden');
    } else {
      parent.className = `${baseClass} ${classError}`;
    }
  };

  inputElement.addEventListener('keyup', event => {
    if (event.key === 'Enter') {
      return;
    }
    onKeyUpHandler(inputElement);
  });
  inputElement.addEventListener('keydown', async event => {
    if (event.key === 'Enter') {
      await onSubmitHandler(inputElement);
    }
  });
  inputButton.addEventListener('click', () => onSubmitHandler(inputElement));
};
